import SocialBarIcon from "@assets/social/icons.svg";
import ShareSocial, {
  SocialVariant,
} from "@components/Blocks/ShareSocial/ShareSocial";
import { isMobileOrTablet } from "@helper/utils";
import { NoSSR } from "@sphtech/web2-core/components";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

type ShareSocialBarProps = {
  dateCreated: string;
  pageUrl: string;
  socialIconList: string[];
  title: string;
  renderButton?: (onClick: () => void) => React.ReactNode;
  className?: string;
  onClickGaEvent?: () => void;
};

export function ShareSocialBar({
  dateCreated,
  pageUrl,
  socialIconList,
  title,
  renderButton,
  className = "",
  onClickGaEvent,
}: ShareSocialBarProps) {
  const shareData = {
    url: pageUrl,
  };

  const [expandedSocialBar, setExpandedSocialBar] = useState(false);
  // Toggle the dropdown menu
  const toggleDropdown = () => {
    if (isMobileOrTablet()) {
      try {
        void navigator.share(shareData);
      } catch (err) {
        setExpandedSocialBar((prev) => !prev);
      }
    } else {
      setExpandedSocialBar((prev) => !prev);
    }
    if (onClickGaEvent && !expandedSocialBar) {
      onClickGaEvent();
    }
  };

  return (
    <div className="relative">
      {renderButton ? (
        renderButton(toggleDropdown)
      ) : (
        <button onClick={toggleDropdown}>
          <img src={SocialBarIcon} width={24} height={24} alt="share-buttons" />
        </button>
      )}
      <div
        className={twMerge(
          `
          w-max flex p-2 bg-white-900 transition-all duration-300 rounded-[30px]
          absolute z-10 top-6 -right-1
          ${expandedSocialBar ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"}`,
          className,
        )}
      >
        <div className="flex self-end gap-2">
          <NoSSR>
            {socialIconList.map((variant, index) => (
              <ShareSocial
                variant={variant as SocialVariant}
                pagePath={pageUrl}
                pageTitle={title}
                dateCreated={dateCreated}
                key={index}
              />
            ))}
          </NoSSR>
        </div>
      </div>
    </div>
  );
}
